<div class="px-[16px]">
  <youtube-player [videoId]="videoId" class="notion-video__player" [height]="320"></youtube-player>
</div>
